import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useCountdown } from '@/js/libs/hooks/useCountdown';
import { Badge } from '@/js/libs/ui/src/V2';
import { useAuth, useSelectCompany } from '@/js/libs/use-auth';

export const TemporaryAccessTimer = memo(function TemporaryAccessTimer() {
  const [t] = useTranslation(['components']);

  const { selectedCompany, temporaryAccessExpiresAt } = useAuth();
  const selectCompany = useSelectCompany();

  const handleExpire = useCallbackRef(() => selectCompany(null));

  const { min, sec } = useCountdown(temporaryAccessExpiresAt, handleExpire);

  if (!selectedCompany?.temporaryAccessRequired || !temporaryAccessExpiresAt) {
    return null;
  }

  const time = `${min}:${String(sec).padStart(2, '0')}`;

  return (
    <Badge
      informative
      dataTestId='temporary-access-timer'
      title={t('components:TEMPORARY_ACCESS_TIME', {
        time,
        defaultValue: 'Temporary access time {{time}}',
      })}
    />
  );
});
